export const MUTATE_LOCALE = 'MUTATE_LOCALE';

interface ILocalizationStore {
    locale: string;
}

// initial state
const LocalizationState: ILocalizationStore = {
    locale: 'us',
};

// getters
const getters = {
    locale: ( state: ILocalizationStore ) => state.locale,
};

// mutations
const mutations = {
    [MUTATE_LOCALE](state: ILocalizationStore, payload: string) {
        state.locale = payload;
    },
};

// actions
const actions = {
};

export default {
    state: LocalizationState,
    getters,
    actions,
    mutations,
};
